import { getMonthOptionsByIndex, getYearOptions } from '@/_schemas/generic/date-calendar-schemas';

import { strToAwardType } from '../components/award-type';
import { type AwardFormSchema, type AwardQuerySchema } from '../schemas';

const monthOptions = getMonthOptionsByIndex();
const yearOptions = getYearOptions();

export function awardQueryToForm({
  award_year,
  award_month,
  sponsoring_organization,
  notes,
  award_type,
  gallery,
  ...data
}: AwardQuerySchema): AwardFormSchema {
  return {
    ...data,
    award_year: yearOptions.find((option) => option.value === `${award_year}`) || null,
    award_month: monthOptions.find((option) => option.value === award_month) || null,
    sponsoring_organization: sponsoring_organization || '',
    notes: notes || '',
    award_type: strToAwardType(award_type),
    gallery: gallery || [],
  };
}
